import Vue from 'vue';

//Plugins
import '@/clir/plugins/dayjs/dayjs';

const mixins = [];
const directives = {};

// custom directive, détection de clic en dehors de l'élément
import clickOutside from "@/clir/directives/clickOutside";
directives["clickOutside"] = clickOutside;

// custom directive, contrôle du statut de chargement d'un composant
import loading from "@/clir/directives/loading";
directives["loading"] = loading;

// utilitaire d'export
import exportDatas from "@/clir/mixins/utils/exportDatas";
mixins.push(exportDatas);

// utilitaire objet
import objectUtils from "@/clir/mixins/utils/objectUtils";
mixins.push(objectUtils);

// utilitaire de chargement d'image depuis assets/img :
import handleImage from "@/clir/mixins/utils/handleImage";
mixins.push(handleImage);

// mapping des fonctions getters en mixins
import storeGetters from "@/clir/mixins/store/getters";
mixins.push(storeGetters);

// mapping des fonctions actions en mixins
import storeActions from "@/clir/mixins/store/actions";
mixins.push(storeActions);

// Enregistrement des mixins globaux :
mixins.forEach(e => Vue.mixin(e));

// Enregistrement des customs directives globales :
Object.keys(directives).forEach(key => {
    Vue.directive(key, directives[key])
})

Vue.config.productionTip = false;

export default Vue;
